import { apiClient } from "@/api";
import { ApiResponse } from "@/types";
import {
  GetInquiryListParams,
  InquiryDetail,
  InquiryListData,
  InquiryReply,
  InquiryStatus,
} from "@/types/inquiry";

import { AxiosRequestConfig } from "axios";

export async function getInquiryList(params: GetInquiryListParams, config?: AxiosRequestConfig) {
  return apiClient.get<ApiResponse<InquiryListData>>("admin/inquiries/", {
    ...config,
    params,
  });
}

export async function deleteInquiry(id: string, config?: AxiosRequestConfig) {
  return apiClient.delete(`admin/inquiries/${id}`, config);
}

export async function updateInquiryStatus(inquiry_id: string, status: InquiryStatus, config?: AxiosRequestConfig) {
  return apiClient.patch(`admin/inquiries/${inquiry_id}/status`, { status }, config);
}

export async function getInquiryDetail(id: string, config?: AxiosRequestConfig): Promise<InquiryDetail> {
  const { data } = await apiClient.get<ApiResponse<InquiryDetail>>(`/admin/inquiries/${id}`, config);
  return data.data;
}

export async function sendInquiryReply(inquiry_id: string, content: string, config?: AxiosRequestConfig): Promise<InquiryReply> {
  const { data } = await apiClient.post<ApiResponse<InquiryReply>>(
    `/admin/inquiries/${inquiry_id}/reply`,
    { content },
    config,
  );
  return data.data;
}

export async function completeInquiry(id: string, config?: AxiosRequestConfig): Promise<void> {
  await apiClient.patch(
    `/admin/inquiries/${id}/status`,
    { status: "completed" },
    config,
  );
}

export async function markInquiryRead(id: string, config?: AxiosRequestConfig): Promise<void> {
  await apiClient.post(`/admin/inquiries/${id}/read`, undefined, config);
}
